import React, {Component} from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

export const Donate = () => {
  
  //this.state = {inputStyle: 'mfc-modal__input-none'};
    //this.handleChange = this.handleChange.bind(this);*/
  
  let self = this
  //self.state = {showInput: true, one: true, inputStyle: "mfc-modal__input-none"};
  let checked = ''

  function validateSum () {
  if (document.form.sum.value < 10) {
  	document.getElementById('errorSum').innerHTML = 'Минимальная сумма для пожертвования - 10 рублей<br>';
    } else {
  	  document.getElementById('errorSum').innerHTML = '';
    }
  }
  
  function validateCheck () {
    if (!document.form.agreement.checked) {
  	  document.getElementById('errorCheck').innerHTML = 'Необходимо согласие с условиями публичной оферты<br>';
    } else {
  	  document.getElementById('errorCheck').innerHTML = '';
    }
  }
  
  function cloudPay(name, sum) {
    name = document.form.name.value;
    sum = document.form.sum.value;
    let agreement = document.form.agreement.checked;
  
    if (agreement && (sum >= 10)) {
      var widget = new window.cp.CloudPayments();
      widget.charge({ // options
          publicId: 'pk_a0bfcde307ec1471adacb6507f37d',  //id из личного кабинета
          description: 'Пожертвование', //назначение
          amount: Number(sum),//10, //сумма
          currency: 'RUB', //валюта
          invoiceId: '1234567', //номер заказа  (необязательно)
          skin: "mini", //дизайн виджета
          data: {
              projectId : '60d4b133b6d342f3da0aef4c', //признак пожертвования на Kynsi
              name: name //имя
            }
        },
        function (options) { // success
           var win = window.open('/', '_self');
    	   win.focus();
    	   return (true)
        },
        function (reason, options) { // fail
        });
    } else {
      if (sum < 10) {
        document.getElementById('errorSum').innerHTML = 'Минимальная сумма для пожертвования - 10 рублей<br>';
        console.log('Минимальная сумма для пожертвования - 10 рублей');
      }
      if (!agreement) {
        document.getElementById('errorCheck').innerHTML = 'Необходимо согласие с условиями публичной оферты<br>';
        console.log('Необходимо согласие с условиями публичной оферты');
      }
    }
  }

  function changeSum(sum) {
    console.log('sum', sum)
    if (checked && checked != 'other') {
      document.getElementById(checked).className = "mfc-modal__btn-radio-s"
    } else if (checked) {
      document.getElementById(checked).className = "mfc-modal__btn-radio-m"
    }
    if (document.form && sum && sum != 'other') {
      document.form.sum.value = sum
      /*self.state.showInput = false
      self.state.inputStyle= "mfc-modal__input-none"*/
      document.getElementById('sum').className = "mfc-modal__input-none"
      document.getElementById(sum.toString()).className = "mfc-modal__btn-radio-s-checked"
      checked = sum.toString()
    } else {
      document.getElementById('sum').className = "mfc-modal__input"
      document.getElementById(sum).className = "mfc-modal__btn-radio-m-checked"
      checked = sum
    }
  }

  let kynsi = {
    _id: '1', image: '/assets/img/kynsi.png', title: '',
    link: ''
  }

  let anton = {
    _id: '1', image: '/assets/img/anton.jpg', title: '',
    link: ''
  }

  return (
  <div className='Donate Kynsi'>
  <div className='Container Container_light'>
    <Helmet>
      <title>Пожертвовать MFC</title>
    </Helmet>
    <Overlay isActive={true}>
      <div className="mfc-modal-content donate">
        <form name='form'>
        <div className="mfc-modal__input-wrapper">
          <label htmlFor="name">Имя (опционально)</label>
          <input
            className='mfc-modal__input'
            type="text"
            name="name"
            id="name"
            placeholder="Кому мы благодарны"            
          />
        </div>
        <div className="mfc-modal__input-wrapper">
          <label htmlFor="sum">Сумма пожертвования</label>
          { <input
            className='mfc-modal__input-none'
            type="number"
            name="sum"
            id="sum"
            min="10"
            onChange={validateSum}
            required
          />}
          <div className='mfc-modal__btn-radio-group'>
          <a className='mfc-modal__btn-radio-s' id="300" onClick={() => changeSum(300)}>300 ₽</a>
          <a className='mfc-modal__btn-radio-s' id="500" onClick={() => changeSum(500)}>500 ₽</a>
          <a className='mfc-modal__btn-radio-s' id="1000" onClick={() => changeSum(1000)}>1000 ₽</a>
          </div>
          <div className='mfc-modal__btn-radio-group'>
          <a className='mfc-modal__btn-radio-m' id="other" onClick={() => changeSum('other')}>Другая сумма</a>
          </div>
        </div>
        <div className="mfc-modal__checkbox-wrapper">
          <div className="checkbox">
            <input className="custom-checkbox" type="checkbox" id="color-1" name="agreement" value="indigo" onChange={validateCheck} />
              <label htmlFor="color-1">Согласен с условиями&nbsp;
                <a href="https://meetforcharity.today/help/offer" target="_blank" className="mfc-modal__link">
                  публичной оферты
                </a>
              </label>
          </div>
          <span id='errorSum' className='error'></span>
          <span id='errorCheck' className='error'></span>
        </div>
          <a className='mfc-modal__btn-submit' onClick={cloudPay}>Помогаю!</a>
        </form>
        <div className='thanks' >
          <b>Спасибо!</b>
        </div>
        <div className="mfc-modal__logo-list">
          <div className='Header__logo-img logo logo-mossport'>
		        <a href='https://kynsi.ru'>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="-220 -30 550 70" style={{ overflow:'visible' }} >
                <g fill="white" fill-rule="evenodd"> 
                  <path d="M3.83,2.44H.35A.33.33,0,0,1,0,2.09v-.9C0,1,.14.91.35.91H10.64a.47.47,0,0,1,.49.49V24L33.25,1.4a1.61,1.61,0,0,1,1-.49h4.32c.21,0,.34.07.34.28v.9a.32.32,0,0,1-.34.35H35.61L17.11,21.36a215.76,215.76,0,0,0,17.6,19c2.71,2.37,4.8,4,7.23,4a5.61,5.61,0,0,0,2.51-.7c.14,0,.21.14.35.35a1.69,1.69,0,0,1,.27.63c0,.14-.14.34-.55.62a12.58,12.58,0,0,1-6.82,2.09,12.84,12.84,0,0,1-9.25-3.62C23.31,39.51,16.07,31,11.13,24.7V45.42h3.62a.33.33,0,0,1,.35.35v.91c0,.21-.14.27-.35.27H4.32a.48.48,0,0,1-.49-.48Z" ></path> <path d="M89.28,25C84.9,17.88,79.68,9.6,74.61,2.44h-3.2a.33.33,0,0,1-.35-.35v-.9c0-.21.14-.28.35-.28H82.25a1.08,1.08,0,0,1,.77.48C86.91,7,91.85,15.1,95.88,21.85c4-6.75,8.91-15.17,12.59-20.32a1.11,1.11,0,0,1,.91-.62h5.29c.21,0,.35.07.35.28v.9a.33.33,0,0,1-.35.35h-3.55c-4.66,6.4-9.67,14.25-14.47,22.26V45.42h3.83a.33.33,0,0,1,.35.35v.91c0,.2-.14.27-.35.27H89.76a.47.47,0,0,1-.48-.48Z" ></path> <path d="M154.43,45.07h4.73a.33.33,0,0,1,.35.35v1.26c0,.2-.14.27-.35.27h-6.89a.48.48,0,0,1-.49-.48v-44h-3.54a.33.33,0,0,1-.35-.35v-1c0-.21.14-.28.35-.28h5.63a1.56,1.56,0,0,1,1,.55c10.37,10.92,26.78,26.71,36.8,35.54V1.53a.55.55,0,0,1,.63-.62h5.56c.21,0,.35.07.35.28v.9a.33.33,0,0,1-.35.35h-3.55V47.16a.43.43,0,0,1-.48.48h-.56a1.33,1.33,0,0,1-.91-.48,463.33,463.33,0,0,1-38-35.75Z"></path> <path d="M238.25,8.56c0,4.24,4.17,6.89,11.54,10.36s13.08,7.79,13.08,15.65S256.54,48,246.73,48a23.51,23.51,0,0,1-14.33-4.94c-.76-.63-1.11-1-1.11-1.4a1.67,1.67,0,0,1,.42-.9c.28-.35.42-.48.76-.48s.7.34,1.05.55c2.29,1.53,6.95,4.52,13.15,4.52,6,0,10.43-2.78,10.43-7.65,0-5.28-5.29-8.7-12.73-12.31-8.28-4-11.48-7.79-11.48-14.19,0-7,6-11.2,14.33-11.2a19.85,19.85,0,0,1,9.39,2.44c2.16,1.18,3.83,2.64,3.83,4.66A2.84,2.84,0,0,1,257.52,10a2.78,2.78,0,0,1-2.86-2.85,3,3,0,0,1,2-2.72A17.77,17.77,0,0,0,247.85,2c-5.29,0-9.6,2.09-9.6,6.54" fill="white"></path> <path d="M300.73,2.44h-3.48a.33.33,0,0,1-.35-.35v-.9c0-.21.14-.28.35-.28h10.37a.48.48,0,0,1,.48.49v44h3.55a.33.33,0,0,1,.35.35v.91c0,.21-.14.27-.35.27H301.22a.48.48,0,0,1-.49-.48Z" />
                </g>
              </svg>
            </a> 
          </div>
          <div className="Header__logo-img">
            <a href="https://businessforcharity.today/" alt="businessforcharity.today" title="businessforcharity.today">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="-80 0 300 40">
                <g fill="white" fill-rule="evenodd">
                  <path d="M0 18.769h3.956l2.945 8.678 2.873-8.678h3.868v12.635h-2.608v-8.979L7.93 31.404H5.783l-3.14-8.89v8.89H0zM19.77 23.81c-1.119 0-1.899.78-2.041 2.057h4.009c-.106-1.117-.71-2.058-1.969-2.058m.089 7.861c-2.82 0-4.683-1.916-4.683-4.791 0-2.84 1.933-4.898 4.594-4.898 2.768 0 4.524 2.023 4.524 5.236v.248h-6.564c.035 1.58.798 2.43 2.146 2.43.923 0 1.49-.407 1.863-1.33h2.412c-.567 1.987-2.217 3.105-4.292 3.105m10.37-7.86c-1.118 0-1.898.78-2.04 2.057h4.008c-.106-1.117-.709-2.058-1.968-2.058m.088 7.861c-2.82 0-4.683-1.916-4.683-4.791 0-2.84 1.934-4.898 4.595-4.898 2.767 0 4.523 2.023 4.523 5.236v.248h-6.563c.035 1.58.798 2.43 2.146 2.43.923 0 1.49-.407 1.862-1.33h2.413c-.567 1.987-2.217 3.105-4.293 3.105m10.91-7.719h-1.863v4.312c0 .887.018 1.296 1.1 1.296.266 0 .461 0 .763-.036v1.917c-.692.053-.958.07-1.526.07-2.164 0-2.838-.567-2.838-2.803v-4.756h-1.526v-1.703h1.526V19.48h2.501v2.768h1.863v1.703zM57.484 13.31H46.746v6.376h9.475v2.269h-9.475v9.449h-2.699V10.955h13.437zM61.266 23.994c0 3.648 1.751 5.802 4.737 5.802 2.87 0 4.594-2.183 4.594-5.83 0-3.533-1.78-5.773-4.651-5.773-2.872 0-4.68 2.268-4.68 5.801m11.828-.086c0 5.026-2.612 7.956-7.12 7.956-4.536 0-7.235-2.93-7.235-7.812 0-4.883 2.785-7.898 7.264-7.898s7.091 2.843 7.091 7.754m10.623-5.141c-.259-.029-.373-.029-.632-.029-4.02 0-4.737 3.074-4.737 6.405v6.261h-2.44v-14.82h2.325v3.188c1.033-2.498 2.842-3.533 5.484-3.533v2.528zm17.142 13.326c-8.484 0-14.039-6.29-14.039-15.982 0-8.616 4.995-16.11 14.297-16.11 5.9 0 11.843 3.704 12.532 9.95h-2.928c-.948-4.566-4.694-7.41-9.69-7.41-6.804 0-11.325 5.429-11.325 13.57 0 8.142 4.435 13.484 11.24 13.484 6.158 0 9.56-4.222 10.206-9.952h2.885c-.646 7.583-5.814 12.45-13.178 12.45m19.81-18.653c1.593-3.187 4.005-4.738 7.665-4.738 5.168 0 7.752 2.972 7.752 8.056v14.646h-2.713V17.102c0-3.79-1.766-6.117-5.684-6.117-5.04 0-6.977 3.963-6.977 8.745v11.674h-2.67V.732h2.67c0 13.398 0 11.028-.043 12.708m28.723 7.453c-2.8.387-6.589 1.034-6.589 4.653 0 2.584 1.981 4.221 5.082 4.221 4.048 0 7.536-2.585 7.536-6.806v-3.619c-.861.948-3.057 1.163-6.029 1.55zm11.197 10.382c-.732.258-1.378.345-2.153.345-2.627 0-2.886-2.025-2.886-4.05-1.808 2.886-4.607 4.437-8.354 4.437-4.522 0-7.235-2.326-7.235-6.203 0-4.05 2.756-6.29 8.225-6.85 3.488-.344 5.383-.43 6.46-1.162.56-.388.775-.991.775-2.111 0-3.662-2.24-4.782-5.77-4.782-3.747 0-5.685 1.637-6.03 5.212h-2.583c.215-4.739 3.445-7.452 8.914-7.452 4.996 0 8.14 2.196 8.14 6.375v12.062c0 1.336-.044 2.24 1.464 2.24.344 0 .56 0 1.033-.129v2.068zm14.254-19.6c-.302 0-.56-.044-.732-.044-3.316 0-6.201 2.068-7.062 5.255-.345 1.336-.517 2.628-.517 5.471v9.047h-2.67V9.262h2.54v5.298c1.852-4.049 3.962-5.556 8.441-5.643v2.757zm2.282 19.729h2.713V9.262h-2.713v22.142zm0-26.364h2.713V.603h-2.713V5.04zm16.752 6.419h-4.565v14.043c0 2.24-.086 3.705 2.8 3.705.473 0 .99-.043 1.765-.129v2.326c-.99.13-1.421.172-2.368.172-1.938 0-4.092-.388-4.608-2.541-.216-.905-.259-1.55-.259-4.868V11.459h-3.918V9.262h3.918V2.499h2.67v6.763h4.565v2.197zm12.445 20.763c-1.938 5.17-2.97 7.583-6.545 7.583-.819 0-1.594-.087-2.369-.216v-2.37c1.034.26 1.335.302 1.938.302 2.627 0 3.359-2.628 4.737-6.29l-8.914-21.969h2.97l5.987 15.25c.775 2.025.474 1.292 1.335 3.92.69-2.24.947-3.188 1.335-4.222l5.47-14.948h2.756l-8.7 22.96z"/>
                </g>
              </svg>
              <img src="" width="60" alt="BFC" className="logo-item-small" />
            </a>
          </div>
        </div>
      </div>
      <div className='balright' >
        <img className='ball_img' src={anton.image} alt='anton' />
      </div>
    </Overlay>
  </div>
  </div>
)
}

export default injectIntl(compose(
)(Donate))


// WEBPACK FOOTER //
// ./src/containers/Buttons/DonateKynsi.jsx